import { io, type Socket } from "socket.io-client";
import type {
  ClientToServerEvents,
  ServerToClientEvents,
} from "@spieleparadies/shared";

import { SERVER_URL } from "./env";
import { usePlayerStore } from "../state/usePlayerStore";
import { useRoomStore } from "../state/useRoomStore";
import { useCustomSoundsStore } from "../state/useCustomSoundsStore";

export type AppSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

let socket: AppSocket | null = null;

/**
 * Gibt die Singleton-Socket-Instanz zurück. Beim ersten Aufruf wird der
 * Socket erstellt und *persistente* Listener registriert, die unabhängig
 * vom React-Lifecycle die Stores aktuell halten. So gehen Events nie
 * verloren — auch nicht, wenn React Effects kurzzeitig abgebaut werden
 * (z.B. StrictMode im Dev).
 */
export function getSocket(): AppSocket {
  if (!socket) {
    socket = io(SERVER_URL, {
      autoConnect: true,
      transports: ["websocket"],
    });

    // --- Persistente Store-Sync (nie abgemeldet) ---

    socket.on("session:identity", ({ playerId }) => {
      usePlayerStore.getState().setId(playerId);
    });
    socket.on("disconnect", () => {
      usePlayerStore.getState().setId(null);
    });

    socket.on("room:update", (room) => {
      useRoomStore.getState().setRoom(room);
    });
    socket.on("room:closed", () => {
      useRoomStore.getState().setRoom(null);
    });

    socket.on("room:sound-state", ({ sounds }) => {
      useCustomSoundsStore.getState().setAll(sounds);
    });
    socket.on("room:sound-update", ({ sound }) => {
      useCustomSoundsStore.getState().upsert(sound);
    });
    socket.on("room:sound-removed", ({ key }) => {
      useCustomSoundsStore.getState().remove(key);
    });
  }
  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}
